module.exports = __webpack_public_path__ + "static/media/third-pos.6f8f9950.svg";